module.exports = __webpack_public_path__ + "img/kjzsf.8c79e68e.png";